import { render, staticRenderFns } from "./SupportPage.vue?vue&type=template&id=5cf8c054&scoped=true&"
import script from "./SupportPage.vue?vue&type=script&lang=ts&"
export * from "./SupportPage.vue?vue&type=script&lang=ts&"
import style0 from "./SupportPage.vue?vue&type=style&index=0&id=5cf8c054&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf8c054",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VCard,VCardText,VCardTitle,VContainer,VDivider,VList,VListItem,VMain})
